import { Check } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useLeaderboard } from "../../context/LeaderboardContext";
const ValorClashCard = ({ gameId, setGameId }) => {
  // ------------ Constants --------------
  const [leaderboard, setLeaderboard] = useState();
  const { gameLeaderboard } = useLeaderboard();

  // ------------ Handelers -------------
  const fetchGameLeaderboard = async (gameId) => {
    try {
      const response = await gameLeaderboard(gameId);
      setLeaderboard(response.data.data);
    } catch (error) {
      console.log("Error fetching game leaderboard", error);
    }
  };

  // ----------- Use Effects ------------
  useEffect(() => {
    fetchGameLeaderboard(gameId);
  }, [gameId]);
  return (
    <div className="valorclash-card-inner ">
      <h3>{leaderboard?.gameName}</h3>
      <div className="overview-info">
        <div className="rank-info valor-clash-cards">
          <div className="overview-card-modal">
            <span>Game Rank</span>
            <h3>{leaderboard?.rank}</h3>
          </div>
          <div className="overview-card-modal">
            <span>Tournaments</span>
            <h3>{leaderboard?.tournamentsPlayed}</h3>
          </div>
          <div className="overview-card-modal">
            <span>Trophies</span>
            <h3>{leaderboard?.trophies}</h3>
          </div>
        </div>
        <div className="tasks-list">
          <div className="task-item">
            {" "}
            <span>Tasks</span>
          </div>
          <div className="task-item done">
            {" "}
            <h6>Attend {leaderboard?.task?.tournaments} tournaments</h6>{" "}
            {/* <span>55/70</span> */}
          </div>
          <div className="task-item done">
            {" "}
            <h6>
              {leaderboard?.medals?.gold} Gold Medals,{" "}
              {leaderboard?.medals?.silver} Silver Medals and{" "}
              {leaderboard?.medals?.bronze} Bronze Medals
            </h6>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValorClashCard;
